export default {
  carrier: require('./carrier').default,
  'job-import': require('./job-import').default,
  'order-intake-forms-identification':
    require('./order-intake-forms/identification').default,
  'order-intake-forms-urls': require('./order-intake-forms/urls').default,
  templates: require('./templates').default,
  'brand-assets': require('./brand-assets').default,
};
